import React from 'react'

const Line = () => {
  return (
    <div className='line'>
    </div>
  )
}
const VerticalLine =()=>{
    return(<div className='vertical_line'>

    </div>)
}

export {VerticalLine , Line}